import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const authToken = localStorage?.getItem('token');
    if (authToken && authToken.length > 0 && !req.url.includes('login')) {
      req = req.clone({
        setHeaders: {
          'X-Auth-Token': authToken,
        },
      });
    }
    return next.handle(req);
  }
}
